const twofactorSignupTemplate = require("./signup.html.slim");
declare var angular;

export class TwofactorSignup {
  static $inject = ['users', '$location', 'brand'];

  tfaMethod: string;
  code: string;
  qrCode: string;
  step: string;
  hideSmsCode: boolean = false;
  brandFullName: string;
  error: string;
  errorMaxRetries: string = '';
  loading: string;
  backErrors: Array<string>;

  constructor(
    private users,
    private $location,
    private brand,
  ) {
    this.brandFullName = this.brand.getBrandFullName();
    /* Added this to watch for possible errors related to the phone number, 
    so the dialog can move back to the phone number input if needed. */
    this.backErrors = ['Your number appears to be blocking our SMS messages. Text "YES" to 604-265-6699 to unblock us, then try again.',
      "That number isn't valid. Please enter a complete phone number, starting with its area code.",
      "Ce numéro n'est pas valide. Veuillez entrer un numéro de téléphone complet, en commençant par son indicatif régional.",
      "Please enter a North American phone number, starting with its area code.",
      "Please enter a SMS enabled phone number, starting with its area code.",
      "Something's not right. Please try again and let us know if the problem persists."];
  }

  rememberDevice() {
    this.users.rememberDeviceTwoFactorAuth()
      .then(() => {
        this.error = '';
        this.step = 'success';
      })
      .catch((error) => {
        this.code = '';
        this.error = error.data.message;
      });
  }

  confirmCode(code) {
    this.users.confirmTwoFactorAuth(code)
      .then(() => {
        this.code = null;
        this.error = '';
        this.step = 'remember';
      })
      .catch((error) => {
        this.code = null;
        this.error = error.data.message;
      });
  }

  requestCode() {
    if(this.errorMaxRetries === '' || this.tfaMethod === 'authenticator'){
      this.loading = "loading";
      this.users.requestTwoFactorAuth()
        .then((resp) => {
          if (this.tfaMethod === 'sms') {
            this.error = '';
            this.loading = "loaded";
            this.hideSmsCode = true;
            setTimeout(() => this.hideSmsCode = false, 20000);
          }
          if (this.tfaMethod === 'authenticator') {
            this.qrCode = resp;
            this.step = 'qr';
            this.error = '';
          }
        })
        .catch((error) => {
          this.loading = "";
          if (error.data.error_code && error.data.error_code === 'max_retries_reached') {
            this.errorMaxRetries = error.data.message;
            this.resetSendError();
          }else if(this.backErrors.includes(error.data.message)){
            this.error = error.data.message;
            this.changeStep('info');
          }else{
            this.error = error.data.message;
          }
        });
    }
  }

  resetSendError() {
    this.hideSmsCode = true;
    this.loading = "";
    setTimeout(() => { 
      this.errorMaxRetries = '';
      this.hideSmsCode = false;
    }, 120000);
  }

  enableTwoFactor(phone) {
    this.users.enableTwoFactorAuth(phone, this.tfaMethod)
      .then(() => {
        if(this.tfaMethod === 'authenticator'){
          this.requestCode();
        }else{
          this.changeStep('code');
        }
      })
      .catch((error) => {
        this.error = error.data.message;
      });
  }

  skip() {
    this.users.skipTwoFactorAuth()
      .then((data) => {
        this.$location.url('/dashboard');
      })
      .catch((error) => {
        this.error = error.data.message;
      });
  }

  done() {
    this.$location.url('/dashboard');
  }

  changeStep(step) {
    this.step = step;
    if(this.step === 'code' && this.tfaMethod === 'sms'){
      this.requestCode();
    }
  }
}

angular.module('wbComponents').directive('wbTwofactorSignup', function() {
  return {
    restrict: 'E',
    templateUrl: twofactorSignupTemplate,
    controller: TwofactorSignup,
    controllerAs: 'signup',
    bindToController: true,
  };
});
